<template>
  <div class="feed-item">
    <div class="body-wrapper">
      <div class="feed-content">
        <FeedHeader :feed="feed" :feedType="feedType" />
        <div class="feed-summary">{{ cutOutContent }}</div>
        <div class="link-wrapper">
          <a href="javascript:;" @click="viewDetail">查看详情</a>
        </div>
        <div class="video-cover-wrap">
          <img
            @click="viewDetail"
            src="../../../assets/image/cl_video_img.png"
          />
        </div>
      </div>
    </div>
    <div class="footer-wrapper">
      <FeedFooter :feed="feed" :feedType="feedType" />
    </div>
    <div>
      <el-dialog
        :visible.sync="dialogVisible"
        :show-close="false"
        custom-class="handlian-loading-detail"
        width="540px"
      >
        <div
          class="loading-feed-detail"
          v-loading="loading"
          element-loading-text="加载详情中"
          element-loading-spinner="el-icon-loading"
        ></div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { sliceFeedContent } from "../../../utils/feed";
import FeedHeader from "./feed-header";
import VideoElement from "../../friend/feed-elements/video-element";
import FeedFooter from "./feed-footer";
import { apiMap } from "../../../utils/apiMap";
export default {
  name: "album-item",
  props: {
    feed: {
      type: Object,
      required: true,
    },
    page: Number,
  },
  data() {
    return {
      feedType: "4",
      loading: true,
      dialogVisible: false,
    };
  },
  components: {
    FeedHeader,
    VideoElement,
    FeedFooter,
  },
  computed: {
    cutOutContent() {
      return sliceFeedContent(this.feed.content);
    },
  },
  methods: {
    viewDetail() {
      const initUserSign = {
        feedPage: 1,
        articlePage: 1,
        albumPage: 1,
        audioPage: 1,
        videoPage: this.page,
      };
      Store.dispatch("setUserCenterSign", initUserSign);
      // this.$router.push({
      //   path: "detail",
      //   query: { feedID: this.feed.id, feedType: this.feedType },
      // });
      let routerClanCard = this.$router.resolve({
        path: "detail",
        query: { feedID: this.feed.id, feedType: this.feedType },
      });
      window.open(routerClanCard.href, "_blank");
    },
  },
};
</script>
<style scoped>
.feed-item {
  margin-bottom: 15px;
  padding: 15px;
  background-color: #fff;
}

.feed-summary {
  line-height: 25px;
  white-space: pre-wrap;
}

.link-wrapper a {
  color: #1a70db;
}

.loading-feed-detail {
  height: 100px;
}

.video-cover-wrap {
  margin: 8px 0;
}

.video-cover-wrap img {
  border-radius: 5px;
}
</style>